import styled from 'styled-components';

export const SortIconWrapper = styled.span`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
`;

export const SortIconImg = styled.img`
  width: ${({ $active }) => ($active ? '7.433px' : '10.1px')};
  height: ${({ $active }) => ($active ? '8.4px' : '12.767px')};
  aspect-ratio: ${({ $active }) => ($active ? '7.433 / 8.4' : '10.1 / 12.767')};
`;
